




















































































































import SignaturePad from 'signature_pad';
import StatementAccountInfo from '../StatementAccountInfo.vue';
import {
  downLoadFileApi,
  uploadAttachedApi,
  confirmSettlementApi,
  previewSettlementApi,
  addCommissionFileApi,
  deleteSettlementCredentialsApi,
  getAgentSettlementCredentialsApi,
} from '@/api/index';
import { Component, Vue, Prop, ModelSync, Watch, Ref } from 'vue-property-decorator';
import { getImageUrl, previewFile, getDateTimeFormat, getFilenameFromContentDisposition } from '@/utils/function_utils';

@Component({
  name: 'settlingUploadStatementDialog',
  components: {
    StatementAccountInfo,
  }
})
export default class extends Vue {
  @ModelSync('dialogUploadFileVisible', 'changeVisible', { type: Boolean })
  public value!: boolean;

  @Prop() public readonly data!: any;

  @Watch('dialogUploadFileVisible')
  public watchVisible(val: boolean) {
    if (val) {
      this.getAgentSettlementCredentials();
    }
  }

  @Watch('signatureVisible')
  public watchSignatureCanvas(val: SignaturePad) {
    if (val && !this.signaturePad) {
      this.$nextTick(() => {
        this.initSignaturePad();
        this.handleResize();
      })
    }
  }

  get getLan() {
    return this.$i18n.locale;
  }

  public loading = false;
  public signaturePad: any = null;
  public savedImageUrl: string | null = null;
  public signatureData: any = null;
  public signatureVisible = false;
  public uploadFiles: any = [];
  public signedFile: any = {
    fileKey: '',
    filePath: '',
    fileNameOrc: '',
    signatureUrl: '',
    file: ''
  };
  public companySealFile: any = {
    fileKey: '',
    filePath: '',
    fileNameOrc: '',
    companySealUrl: '',
    file: ''
  };
  public agentSettlementCredentials: any = {
    seal: '',
    signature: '',
  }
  public handlePreviewFile = previewFile;
  public getImageUrlFun = getImageUrl;

  public initSignaturePad() {
    const canvas: any = document.getElementById('signature-pad');
    this.signaturePad = new SignaturePad(canvas, {
      backgroundColor: 'rgba(0, 0, 0, 0)', // 透明背景
      minWidth: 1,
      maxWidth: 6,
      penColor: '#000000',
    });
  }

  public handleResize() {
    const canvas: any = document.getElementById('signature-pad');
    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    canvas.width = canvas.offsetWidth * ratio;
    canvas.height = canvas.offsetHeight * ratio;
    canvas.getContext('2d').scale(ratio, ratio);
    this.signaturePad.clear(); // 防止调整大小后画布变形
  }

  public handleSignatureOpera() {
    this.signatureVisible = true;
  }

  public clearSignature() {
    this.signaturePad.clear();
    this.savedImageUrl = null;
    this.signatureData = null;
  }

  public saveSignature() {
    if (this.signaturePad.isEmpty()) {
      this.$message.error(this.$t('index.eSignatureTips7') as string);
      return;
    }
    
    // 转换为PNG格式的Base64字符串
    const base64Data = this.signaturePad.toDataURL('image/png');
    // 转换Base64为Blob
    const byteCharacters = atob(base64Data.split(',')[1]);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'image/png' });
    
    // 转换Blob为ArrayBuffer (流数据)
    const fileReader = new FileReader();
    fileReader.onload = (event: any) => {
      const arrayBuffer = event.target.result;
      this.signatureData = arrayBuffer;
      this.savedImageUrl = base64Data;
      // 调用API保存签名
      this.uploadSignature(arrayBuffer);
    };
    fileReader.readAsArrayBuffer(blob);
  }

  public async uploadSignature(arrayBuffer: any) {
    try {
      const formData = new FormData();
      const file = new File([arrayBuffer], 'signature.png', { type: 'image/png' });
      formData.append('file', file, 'signature.png');
      formData.append('fileType', '1');
      formData.append('type', 'online');
      await uploadAttachedApi(formData);
      // let imgUrl = '';
      // const blob = new Blob([arrayBuffer]);
      // imgUrl = URL.createObjectURL(blob);
      // this.signedFile = {
      //   fileKey: data.data.fileKey,
      //   filePath: data.data.filePath,
      //   fileNameOrc: data.data.fileNameOrc,
      //   signatureUrl: imgUrl || '',
      //   file,
      // };
      this.getAgentSettlementCredentials();
      // const elink = document.createElement("a");
      // elink.download = 'signature.png';
      // elink.style.display = "none";
      // elink.href = imgUrl;
      // document.body.appendChild(elink);
      // elink.click();
      // URL.revokeObjectURL(elink.href); // 释放URL 对象
      // document.body.removeChild(elink);
      this.$message.success(this.$t('index.uploadSuccess') as string);
      this.signatureVisible = false;
    } catch (error) {
    }
  }

  public async getAgentSettlementCredentials() {
    try {
      const { data } = await getAgentSettlementCredentialsApi();
      if (data && data.data[1]) {
        const params1 = {
          fileKey: data.data[1].fileKey,
          filePath: data.data[1].filePath,
          fileNameOrc: data.data[1].fileNameOrc,
        }
        const res1 = await downLoadFileApi(params1);
        const blob1 = new Blob([res1.data]);
        const imgUrl1 = URL.createObjectURL(blob1);
        this.signedFile = Object.assign(this.signedFile, params1);
        this.signedFile.signatureUrl = imgUrl1 || '';
      }
      if (data && data.data[0]) {
        const params2 = {
          fileKey: data.data[0].fileKey,
          filePath: data.data[0].filePath,
          fileNameOrc: data.data[0].fileNameOrc,
        }
        const res2 = await downLoadFileApi(params2);
        const blob2 = new Blob([res2.data]);
        const imgUrl2 = URL.createObjectURL(blob2);
        this.companySealFile = Object.assign(this.companySealFile, params2);
        this.companySealFile.companySealUrl = imgUrl2 || '';
      }
    } catch (error) {
      //
    }
  }

  public beforeUpload(file: any) {
    const fileTypes = ['image/jpeg', 'image/png', 'image/jpg'];
    if (!fileTypes.includes(file.type)) {
      this.$message.error(this.$t('common.fileUploadTips') as string);
      return false;
    } else if (file.size / 1024 / 1024 > 20) {
      this.$message.error(this.$t('index.limitFileSize') as string);
      return false;
    }
    return true;
  }

  public async handleUploadFile(params: any, fileType: number) {
    const file = params.file;
    const formData =  new FormData();
    formData.append('file', file);
    formData.append('fileType', fileType.toString());
    try {
      const { data } = await uploadAttachedApi(formData);
      let imgUrl = '';
      if (['image/jpeg', 'image/png', 'image/jpg'].includes(file.type)) {
        const params = {
          fileKey: data.data.fileKey,
          filePath: data.data.filePath,
          fileNameOrc: data.data.fileNameOrc,
        }
        const res = await downLoadFileApi(params);
        const blob = new Blob([res.data]);
        imgUrl = URL.createObjectURL(blob);
      }
      if (fileType === 0) {
        this.companySealFile = {
          fileKey: data.data.fileKey,
          filePath: data.data.filePath,
          fileNameOrc: data.data.fileNameOrc,
          companySealUrl: imgUrl || '',
          file,
        };
      } else {
        this.signedFile = {
          fileKey: data.data.fileKey,
          filePath: data.data.filePath,
          fileNameOrc: data.data.fileNameOrc,
          signatureUrl: imgUrl || '',
          file,
        };
      }
      this.$message.success(this.$t('index.uploadSuccess') as string);
    } catch(err) {
      //
    }
  }

  public async handleDeleteFile(fileType: number) {
    try {
      await this.$confirm(this.$t("message.delMsgFile") as string, "", {
        confirmButtonText: this.$t("common.confirm") as string,
        cancelButtonText: this.$t("common.cancel") as string,
        type: "warning",
      })
      if (fileType === 0) {
        this.companySealFile = {
          fileKey: '',
          filePath: '',
          fileNameOrc: '',
        };
      } else {
        this.signedFile = {
          fileKey: '',
          filePath: '',
          fileNameOrc: '',
        };
      }
      await deleteSettlementCredentialsApi(fileType);
    } catch (error) {
      //
    }
  }

  public async previewStatement() {
    try {
      this.data.signFlag = true;
      const res = await previewSettlementApi(this.data);
      const blob = new Blob([res.data], { type: 'application/pdf' });
      const elink = URL.createObjectURL(blob);
      window.open(elink);
    } catch (error) {
      //
    }
  }

  public async downloadStatement() {
    try {
      this.data.signFlag = false;
      const res = await previewSettlementApi(this.data);
      if (res) {
        // const blob = new Blob([res.data], { type: 'application/pdf' });
        // const elink = document.createElement("a");
        // elink.download = getFilenameFromContentDisposition(res.headers['content-disposition']) as string;
        // elink.style.display = "none";
        // elink.href = URL.createObjectURL(blob);
        // document.body.appendChild(elink);
        // elink.click();
        // URL.revokeObjectURL(elink.href); // 释放URL 对象
        // document.body.removeChild(elink);
        // this.$message.success(this.$t('message.downloadSuccess') as string);
        const dateTime = (new Date()).getTime();
        const blob = new Blob([res.data]);
        const elink = document.createElement("a");
        elink.download = getDateTimeFormat(dateTime);
        elink.style.display = "none";
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
        this.$message.success(this.$t('message.downloadSuccess') as string);
      }
    } catch (error) {
      //
    }
  }

  public async confirmSettlement() {
    try {
      this.loading = true;
      await confirmSettlementApi(this.data);
      this.$emit('update-data');
    } catch(err) {
      //
    } finally {
      this.loading = false;
    }
  }

  public handleClose() {
    this.$confirm(`<div style="">${this.$t('index.eSignatureTips2') as string}<span style="color: #ff9700;">${this.$t('index.eSignatureTips2_1') as string}</span>${this.$t('index.eSignatureTips2_2') as string}</div>`, this.$t('common.tip') as string, {
      confirmButtonText: this.$t('common.confirm') as string,
      cancelButtonText: this.$t('common.continue') as string,
      dangerouslyUseHTMLString: true,
      type: 'warning',
      showClose: true,
      distinguishCancelAndClose: true,
      closeOnClickModal: false,
      closeOnPressEscape: false,
      cancelButtonClass: 'cancel-text-btn',
      confirmButtonClass: 'confirm-text-btn',
      callback: (action) => {
        if (action === 'confirm') {
          this.clear();
        }
      }
    })
  }

  public clear() {
    // this.clearFiles();
    this.$emit("changeVisible", false);
  }

  public clearFiles() {
    (this.$refs.signedRef as any).clearFiles();
    (this.$refs.companySealRef as any).clearFiles();
    this.signedFile = {
      fileKey: '',
      filePath: '',
      fileNameOrc: '',
    };
    this.companySealFile = {
      fileKey: '',
      filePath: '',
      fileNameOrc: '',
    };
  }
}
